<template>
  <v-container fill-height fluid style="padding-top: 130px">
    <v-row align="center" justify="center" class="text-center">
      <v-col cols="12">
        <v-row class="mb-3">
          <v-col cols="12" class="d-flex justify-center align-center">
            <v-img
              contain
              height="45"
              width="45"
              :src="require(`@/assets/404.png`)"
            ></v-img>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center align-center">
            <h1 class="text-h4" style="color: #21262a;">
              Stránka nenalezena
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center align-center">
            <v-btn color="primary" @click="goBack">Zpět na přehled</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>

export default {
  name: '404',
  methods: {
    goBack() {
      if (this.$route.params.code) {
        this.$router.push({
          name: 'customer.printers',
        });
      } else {
        this.$router.push({
          name: 'printers',
        });
      }
    },
  },
};
</script>
